import { useNavigate } from 'react-router-dom'; // Ensure this is imported
import './App.css';
import { useState } from "react";

function BookingForm({ availableTimes = [], dispatch, submitForm }) { // Default to empty array
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [guests, setGuests] = useState("1");
  const [occasion, setOccasion] = useState("Birthday");

    // Initialize navigate inside the component
    const navigate = useNavigate();


  const handleDateChange = (e) => {
    const newDate = e.target.value;
    setDate(newDate);
    dispatch({ type: 'UPDATE_TIMES', date: newDate });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = { date, time, guests, occasion };
    // submitForm(formData);
    submitForm(formData, navigate); // Pass navigate to submitForm
  };


  return (
    <div>
      <form onSubmit={handleSubmit} style={{ border: '2px solid', padding: '20px',  width: '800px', margin: '200px', fontFamily: "Karla",
      fontSize: '22px', boxShadow: '5px 10px #888888' }}>


        <div style={{ display: 'inline-block', width: '50%'  }}>
        <label htmlFor="res-date">Choose date</label>
        <input
          type="date"
          value={date}
          onChange={handleDateChange}
          style={{
            width: '70%',
            padding: '12px 20px',
            margin: '8px 0',
            boxSizing: 'border-box'
          }} required
        />
        </div>


        <div style={{ display: 'inline-block', width: '50%'  }}>
        <label htmlFor="res-time">Choose time</label>
        <select
          value={time}
          onChange={(e) => setTime(e.target.value)}  
          style={{
            width: '70%',
            padding: '12px 20px',
            margin: '8px 0',
            boxSizing: 'border-box'
          }} required
        >
          
            {availableTimes.map((availableTime) => (
              <option key={availableTime} value={availableTime}>
                {availableTime}
              </option>
            ))}

            
        </select>
         </div>   

         <div style={{ display: 'inline-block', width: '50%'  }}>
        <label htmlFor="guests">Number of guests</label>
        <input
          type="number"
          placeholder="1"
          min="1"
          max="10"
          value={guests}
          onChange={(e) => setGuests(e.target.value)}
          style={{
            width: '70%',
            padding: '12px 20px',
            margin: '8px 0',
            boxSizing: 'border-box'
          }} required
        />
        </div>

      <div style={{ display: 'inline-block', width: '50%'  }}>
        <label htmlFor="occasion">Occasion</label><br/>
        <select
          value={occasion}
          onChange={(e) => setOccasion(e.target.value)} 
          style={{
            width: '70%',
            padding: '12px 20px',
            margin: '8px 0',
            boxSizing: 'border-box'
          }}
        >
          {/* set default throught useState  
          const [occasion, setOccasion] = useState("Birthday"); */}
          <option value="Birthday" >Birthday</option>
          <option value="Anniversary">Anniversary</option>
        </select>
        </div>



        <input type="submit" value="Make Your reservation" style={{  width: '270px', height: '70px', padding: '30px'  }} />

      </form>
    </div>
  );
}

export default BookingForm;
